import { FunctionComponent, lazy, Suspense } from 'react';

const VerificationSaferGamblingQuestionsBadge = lazy(
  () => import('../../../../app-features/profile/sub-pages/verification/badges/VerificationSaferGamblingQuestionsBadge'),
);

const LazyVerificationSaferGamblingQuestionsBadge: FunctionComponent = () => (
  <Suspense fallback={null}>
    <VerificationSaferGamblingQuestionsBadge />
  </Suspense>
);

export default LazyVerificationSaferGamblingQuestionsBadge;
